import { Modal } from './Modal'
import { ModalContent } from './Modal.Content'
import { ModalHeader } from './Modal.Header'
import { ModalFooter } from './Modal.Footer'

const DhlModal = Object.assign(Modal, { Content: ModalContent, Header: ModalHeader, Footer: ModalFooter })

export { DhlModal as Modal }

export type { ModalRef, ModalProps } from './types'
